import reducer, { initialState } from '../../reducers/userInfo/firstNameLastName';
import * as actions from '../../actions/userInfo/firstNameLastName';

const fn = { reducer, initialState, actions };
export default fn;